import React, { useState, useEffect } from "react"
import { connect } from "react-redux"
import {
  Table,
  Row,
  Col,
  Card,
  Typography,
  Flex,
  Space,
  Statistic,
  Empty,
  Spin,
  Tag,
} from "antd"
import {
  getEngWork,
  getEngWorkSuccess,
  getListEngineer,
  getListQuarterTariff,
  resetAccountingFlag,
} from "store/actions"
import { serializeQuery } from "helpers/service_helper"
import { ListQuarterTariff } from "../common/ListQuarterTariff"
import { engWorkColumnsAnt } from "./engWorkColumnsAnt"
import { ListEngineer } from "../common/ListEngineer"
import {
  CalendarOutlined,
  UserOutlined,
  BarChartOutlined,
  SwapOutlined,
  CheckCircleOutlined,
  FileTextOutlined,
  MinusCircleOutlined,
} from "@ant-design/icons"
import "./engWork.scss"

const { Title, Text } = Typography

const ListEngWork = props => {
  const {
    lstEngWork,
    loading,
    onGetEngWork,
    onGetListQuarterTariff,
    onGetEngWorkSuccess,
    matches_sm,
  } = props

  const [quarterId, setQuarterId] = useState(null)
  const [engineerId, setEngineerId] = useState(null)

  const onChange = (pagination, filters, sorter, extra) => {}

  useEffect(async () => {
    if (quarterId) {
      handleSearchEngWork()
    } else {
      onGetEngWorkSuccess()
    }
  }, [quarterId, engineerId])

  const handleSearchEngWork = async val => {
    let searchQuery = {
      qtId: quarterId ? quarterId : "",
      engId: engineerId ? engineerId : "",
    }
    const params = serializeQuery(searchQuery)
    onGetEngWork(params)
  }

  // Format number with thousand separator
  const formatNumber = num => {
    if (num === null || num === undefined) return "0"
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  }

  // Calculate totals
  const totals = lstEngWork?.reduce(
    (acc, item) => ({
      quota: acc.quota + (item.sumAmountEngQuota || 0),
      quotaBurn: acc.quotaBurn + (item.sumAmountEngQuotaBurn || 0),
      processFee: acc.processFee + (item.sumAmountEngProcessFee || 0),
      realWork: acc.realWork + (item.sumAmountEngRealWorkThisQuarter || 0),
    }),
    { quota: 0, quotaBurn: 0, processFee: 0, realWork: 0 }
  ) || { quota: 0, quotaBurn: 0, processFee: 0, realWork: 0 }

  const selectedQuarter = props.lstQuarterTariff?.find(x => x.id === quarterId)

  return (
    <Space direction="vertical" size={16} style={{ width: "100%" }}>
      {/* Filters Section */}
      <Card
        size="small"
        style={{
          borderRadius: 12,
          border: "none",
          boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
        }}
        styles={{ body: { padding: matches_sm ? 12 : 16 } }}
      >
        <Row gutter={[16, 12]}>
          <Col xs={24} md={12}>
            <Space direction="vertical" size={4} style={{ width: "100%" }}>
              <Text type="secondary" style={{ fontSize: 12 }}>
                <CalendarOutlined style={{ marginLeft: 4 }} />
                انتخاب دوره
              </Text>
              <ListQuarterTariff selectQuarter={setQuarterId} props={props} />
            </Space>
          </Col>
          <Col xs={24} md={12}>
            <Space direction="vertical" size={4} style={{ width: "100%" }}>
              <Text type="secondary" style={{ fontSize: 12 }}>
                <UserOutlined style={{ marginLeft: 4 }} />
                انتخاب مهندس (اختیاری)
              </Text>
              <ListEngineer selectEngineer={setEngineerId} props={props} />
            </Space>
          </Col>
        </Row>
      </Card>

      {/* Summary Stats */}
      {quarterId && lstEngWork && lstEngWork.length > 0 && (
        <Row gutter={[12, 12]}>
          <Col xs={12} sm={6}>
            <Card
              size="small"
              style={{
                borderRadius: 10,
                border: "1px solid #e6f7ff",
                background: "#e6f7ff",
              }}
            >
              <Statistic
                title={
                  <Flex align="center" gap={4}>
                    <SwapOutlined style={{ color: "#1890ff" }} />
                    <span style={{ fontSize: 11 }}>تخصیص دوره</span>
                  </Flex>
                }
                value={totals.quota}
                formatter={value => formatNumber(value)}
                valueStyle={{ fontSize: matches_sm ? 14 : 16, color: "#1890ff" }}
              />
            </Card>
          </Col>
          <Col xs={12} sm={6}>
            <Card
              size="small"
              style={{
                borderRadius: 10,
                border: "1px solid #fff2f0",
                background: "#fff2f0",
              }}
            >
              <Statistic
                title={
                  <Flex align="center" gap={4}>
                    <MinusCircleOutlined style={{ color: "#ff4d4f" }} />
                    <span style={{ fontSize: 11 }}>کسورات</span>
                  </Flex>
                }
                value={totals.quotaBurn}
                formatter={value => formatNumber(value)}
                valueStyle={{ fontSize: matches_sm ? 14 : 16, color: "#ff4d4f" }}
              />
            </Card>
          </Col>
          <Col xs={12} sm={6}>
            <Card
              size="small"
              style={{
                borderRadius: 10,
                border: "1px solid #fff7e6",
                background: "#fff7e6",
              }}
            >
              <Statistic
                title={
                  <Flex align="center" gap={4}>
                    <FileTextOutlined style={{ color: "#fa8c16" }} />
                    <span style={{ fontSize: 11 }}>ارجاعی</span>
                  </Flex>
                }
                value={totals.processFee}
                formatter={value => formatNumber(value)}
                valueStyle={{ fontSize: matches_sm ? 14 : 16, color: "#fa8c16" }}
              />
            </Card>
          </Col>
          <Col xs={12} sm={6}>
            <Card
              size="small"
              style={{
                borderRadius: 10,
                border: "1px solid #f6ffed",
                background: "#f6ffed",
              }}
            >
              <Statistic
                title={
                  <Flex align="center" gap={4}>
                    <CheckCircleOutlined style={{ color: "#52c41a" }} />
                    <span style={{ fontSize: 11 }}>انجام شده</span>
                  </Flex>
                }
                value={totals.realWork}
                formatter={value => formatNumber(value)}
                valueStyle={{ fontSize: matches_sm ? 14 : 16, color: "#52c41a" }}
              />
            </Card>
          </Col>
        </Row>
      )}

      {/* Data Table */}
      <Card
        size="small"
        style={{
          borderRadius: 12,
          border: "none",
          boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
        }}
        styles={{ body: { padding: matches_sm ? 8 : 12 } }}
      >
        {!quarterId ? (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={
              <Text type="secondary">لطفاً یک دوره را انتخاب کنید</Text>
            }
            style={{ padding: 40 }}
          />
        ) : (
          <Spin spinning={loading} tip="در حال بارگذاری...">
            <Table
              size="small"
              pagination={{
                pageSize: 15,
                showSizeChanger: true,
                showTotal: total => `${total} مهندس`,
                size: "small",
              }}
              sticky
              scroll={{ x: matches_sm ? 400 : 1000, y: 450 }}
              columns={engWorkColumnsAnt({
                props,
                matches_sm,
                period: selectedQuarter?.period,
                year: selectedQuarter?.year,
              })}
              rowClassName={(_r, i) => (i % 2 ? "odd" : "even")}
              rowKey={record => record.id}
              dataSource={lstEngWork}
              onChange={onChange}
              locale={{
                emptyText: (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="داده‌ای یافت نشد"
                  />
                ),
              }}
            />
          </Spin>
        )}
      </Card>
    </Space>
  )
}

const mapStateToProps = ({ Accounting, QuarterTariffs, Engineers }) => ({
  lstEngWork: Accounting.lstEngWork,
  lstQuarterTariff: QuarterTariffs.lstQuarterTariff,
  lstEngineer: Engineers.lstEngineer,
  error: Accounting.error,
  success: Accounting.success,
  loading: Accounting.loading,
})

const mapDispatchToProps = dispatch => ({
  onGetEngWork: query => dispatch(getEngWork(query)),
  onGetEngWorkSuccess: () => dispatch(getEngWorkSuccess([])),
  onGetListQuarterTariff: () => dispatch(getListQuarterTariff()),
  onGetListEngineer: () => dispatch(getListEngineer()),
  onResetAccountingFlag: () => dispatch(resetAccountingFlag()),
})

export default connect(mapStateToProps, mapDispatchToProps)(ListEngWork)
